import { render, staticRenderFns } from "./serviceField.vue?vue&type=template&id=4b798ef9&scoped=true&"
import script from "./serviceField.vue?vue&type=script&lang=js&"
export * from "./serviceField.vue?vue&type=script&lang=js&"
import style0 from "./serviceField.vue?vue&type=style&index=0&id=4b798ef9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b798ef9",
  null
  
)

export default component.exports